/**
 * h5展示区域组件
 * @author wangyichen
 * @since 2018/08/16
 */
import './h5.less';
import CONFIG from 'constants/config.json5';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PostMessager from '@fe/common/lib/post-messager';
const SIWTCH_PAGE = '__PREVIEW_PAGE_SWITCH__';
const SWITCH_PAGE_SUCCESS = '__PREVIEW_PAGE_SWITCH_SUCCESS__';
const PREVIEW_FIRST_PAGE = '__PREVIEW_PAGE_FIRST_PAGE__';
import QRCode from '@fe/common/lib/qrcode';

// 二维码配置
const QRCODE_CONFIG = {
  // 宽度
  width: 80,
  // 高度
  height: 80,
  //前景色
  colorDark: '#000',
  // 背景色
  colorLight: '#fff',
};
class H5 extends Component {
  // h5 iframe对象的h5Messaager
  h5Messager;
  // 作品的 iframe
  h5Iframe;
  static propTypes = {
    // 跳转的目标页码，0开头，用于监听更新，只能是单向数据流
    targetPage: PropTypes.number,
    // 页面总数
    pageCount: PropTypes.number,
    // 设置页面总数
    setPageCount: PropTypes.func,
    // 设置当前页
    setCurrentPage: PropTypes.func,
    // 基本信息
    baseInfo: PropTypes.object,
    // 是否允许循环翻页
    pageLoop: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.h5Messager = null;
    this.state = {
      isScrolling: false,
      currentPage: 1,
    };
  }
  // 创建二维码
  createQrcode = () => {
    const { appUrl } = this.props.baseInfo;
    const canvas = this.qrCode.querySelector('canvas');
    // 生成二维码
    if (!canvas) {
      new QRCode(this.qrCode, {
        ...QRCODE_CONFIG,
        text: appUrl,
      });
    }
  };
  // 监听h5 iframe
  listenH5Iframe = () => {
    if (!this.h5Iframe || !this.h5Iframe.contentWindow) return;
    this.h5Messager = new PostMessager(this.h5Iframe.contentWindow);
    this.h5Messager.listen(PREVIEW_FIRST_PAGE, data => {
      if (!data || !data.current) return;
      this.setState({
        currentPage: data.current,
      });
      this.props.setCurrentPage(data.current);
    });
    this.h5Messager.listen(SWITCH_PAGE_SUCCESS, data => {
      if (!data || !data.current) return;
      this.setState({
        currentPage: data.current,
      });
      this.props.setCurrentPage(data.current);
    });
  };

  // 去前一页
  goPrev = () => {
    this.h5Messager.send(SIWTCH_PAGE, { type: 'prev' });
  };
  // 去下一页
  goNext = () => {
    this.h5Messager.send(SIWTCH_PAGE, { type: 'next' });
  };

  componentDidMount() {
    this.listenH5Iframe();
    this.createQrcode();
    const { appUrl } = this.props.baseInfo;
    const dealAppUrl = appUrl
      ? appUrl.replace(/(\/m2\/|\/m\/|\/mspa\/)/, '/m2/')
      : '';
    this.h5Iframe.src = `${
      appUrl ? dealAppUrl.replace(/^(https|http):\/\//, '//') + '?mobile=1' : ''
    }`;
    // this.h5Iframe.src =
    //   'http://localhost.rabbitpre.com:12000/m2/qyFZnb6A?mobile=1';
  }
  componentWillUnmount() {
    this.h5Messager && this.h5Messager.close();
  }
  componentWillReceiveProps(nextProps) {
    let direction;
    if (nextProps.targetPage > this.props.targetPage) {
      direction = 'next';
      this.h5Messager.send(SIWTCH_PAGE, {
        type: 'goto',
        targetPage: nextProps.targetPage,
        direction,
      });
    } else if (nextProps.targetPage < this.props.targetPage) {
      direction = 'prev';
      this.h5Messager.send(SIWTCH_PAGE, {
        type: 'goto',
        targetPage: nextProps.targetPage,
        direction,
      });
    }
  }
  render() {
    const { pageCount, pageLoop } = this.props;
    const { currentPage } = this.state;
    const isNoStartLoop = !pageLoop && currentPage === 1;
    const isNoEndLoop = !pageLoop && currentPage === pageCount;
    return (
      <div className="h5-wrap">
        <div className="iframe-wrapper">
          <iframe
            id="h5-iframe"
            key="normal"
            frameBorder={0}
            ref={el => (this.h5Iframe = el)}
            width={CONFIG.PAGE_WIDTH}
            height={CONFIG.PAGE_HEIGHT}
          />
        </div>
        {pageCount > 1 ? (
          <div
            className="page-turning"
            style={{ width: `${CONFIG.PAGE_WIDTH}px` }}>
            <button
              onClick={this.goPrev}
              className={
                isNoStartLoop ? 'btn pull-left' : 'btn btn-loop pull-left'
              }
              disabled={isNoStartLoop}>
              上一页
            </button>
            <span className="page-foot">
              {currentPage}/{pageCount}
            </span>
            <button
              onClick={this.goNext}
              className={
                isNoEndLoop ? 'btn pull-right' : 'btn btn-loop pull-right'
              }
              disabled={isNoEndLoop}>
              下一页
            </button>
          </div>
        ) : null}
        <div className="qrcode">
          <div className="qrcode-img" ref={node => (this.qrCode = node)} />
          <div className="qrcode-desc">扫一扫查看</div>
        </div>
      </div>
    );
  }
}

export default H5;
